module.exports = {"id":true,"operatorCode":true,"operatorName":true}


//////////////////
// WEBPACK FOOTER
// ./src/schemas/user/partners.json
// module id = JCo6
// module chunks = 1